export function encodeQueryStringParams(params: Record<string, string>) {
  return Object.keys(params)
    .map((param) => `${param}=${encodeURIComponent(params[param])}`)
    .join("&");
}

/** Uses JSON.stringify and JSON.parse to deep copy an object. The object must be safely serializable via JSON.stringify. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deepCopyJson(value: any): any | undefined {
  if (value === undefined) {
    return undefined;
  }

  return JSON.parse(JSON.stringify(value));
}

export function removeKeysDeep<T>(obj: T, keyToRemove: string): T {
  if (Array.isArray(obj)) {
    return obj.map((item) => removeKeysDeep(item, keyToRemove)) as unknown as T;
  }

  if (obj !== null && typeof obj === "object") {
    const result = {} as Record<string, unknown>;
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && key !== keyToRemove) {
        result[key] = removeKeysDeep((obj as Record<string, unknown>)[key], keyToRemove);
      }
    }
    return result as unknown as T;
  }

  return obj;
}
